import React from 'react';
const ButtonWrapper = ({ children }: { children: React.ReactNode }) => {
  return <div style={{ margin: '20px' }}>{children}</div>;
};

export default ButtonWrapper;
